import React from 'react';
import extendClassName from '../../../lib/bemUtils/bem';
import { Modifier, appendModifiers } from '../../../lib/bemUtils/Modifier';

export type StateIndicator = {
  status: 'red' | 'green' | 'yellow' | 'purple';
  modifier?: Modifier<
    'flyout-navigation-item' | 'main-navigation-item' | 'inline-block' | 'no-margin-right' | 'border'
  >;
};

export function StateIndicator({ status, modifier }: StateIndicator) {
  return <span className={extendClassName('state-indicator', appendModifiers(status, modifier))} />;
}
